import { bindActionCreators } from "redux";

import { useDispatch, useSelector } from "react-redux";

import { actions } from "../store";

import EditorDrawer from "./components/EditorDrawer";
import ColorComponent from "./components/ColorComponent";
import ImageComponent from "./components/ImageComponent";

export default function NewEditor({}) {
    const dispatch = useDispatch();

    const { setWebSettings } = bindActionCreators(actions, dispatch);

    const { webSettings } = useSelector((store) => store.globalState);

    const setBgColor = (color) => {
        let configs = { ...webSettings };

        configs.pages.current_news.background_color = color;

        setWebSettings(configs);
    };

    const setBgImage = (image) => {
        let configs = { ...webSettings };

        configs.pages.current_news.background_image = image;

        setWebSettings(configs);
    };

    const { background_color, background_image } = webSettings?.pages?.current_news;

    return (
        <EditorDrawer title={"News page settings"}>
            <ImageComponent
                title={"Background image"}
                defaultImage={background_image}
                updateImage={(e) => setBgImage(e)}
                deleteImage={() => setBgImage("")}
            />

            <ColorComponent
                text="Background color"
                defaultColor={background_color}
                callback={setBgColor}
            />
        </EditorDrawer>
    );
}
